module.exports = __webpack_public_path__ + "img/Frontpage2.8be7c9dc.jpg";